var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlashCircleFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#CC0021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8119 4.25471C2.99082 5.28116 2.49984 6.58316 2.49984 7.99984C2.49984 11.3135 5.18613 13.9998 8.49984 13.9998C9.91651 13.9998 11.2185 13.5089 12.245 12.6878L3.8119 4.25471ZM4.75471 3.3119L13.1878 11.745C14.0089 10.7185 14.4998 9.41651 14.4998 7.99984C14.4998 4.68613 11.8135 1.99984 8.49984 1.99984C7.08316 1.99984 5.78116 2.49082 4.75471 3.3119ZM1.1665 7.99984C1.1665 3.94975 4.44975 0.666504 8.49984 0.666504C12.5499 0.666504 15.8332 3.94975 15.8332 7.99984C15.8332 12.0499 12.5499 15.3332 8.49984 15.3332C4.44975 15.3332 1.1665 12.0499 1.1665 7.99984Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashCircleFull);
export default __webpack_public_path__ + "static/media/slash-circle-full.768e6e334d117aad41d6d4c7723da76b.svg";
export { ForwardRef as ReactComponent };